import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Restablecer_clave.css';

const RestablecerClave = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [repite, setRepite] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [esError, setEsError] = useState(false);
  const [completado, setCompletado] = useState(false);

  const validaciones = [
    { texto: '12 caracteres como m\u00EDnimo', ok: password.length >= 12 },
    { texto: 'Dos letras may\u00FAsculas como m\u00EDnimo', ok: /[A-Z].*[A-Z]/.test(password) },
    { texto: 'Una letra min\u00FAscula como m\u00EDnimo', ok: /[a-z]/.test(password) },
    { texto: 'Un n\u00FAmero como m\u00EDnimo', ok: /[0-9]/.test(password) },
    { texto: 'Un car\u00E1cter especial como m\u00EDnimo (. , - _ etc)', ok: /[.,\-_!@#$%^&*]/.test(password) },
  ];

  const todasValidas = validaciones.every(v => v.ok);
  const coinciden = password === repite && repite !== '';

  const handleSubmit = async () => {
    if (!todasValidas) {
      setEsError(true);
      setMensaje('La contrase\u00F1a no cumple los requisitos.');
      return;
    }
    if (!coinciden) {
      setEsError(true);
      setMensaje('Las contrase\u00F1as no coinciden.');
      return;
    }

    setIsLoading(true);
    setMensaje('');

try {
      const response = await fetch(
        `${process.env.REACT_APP_AUTH_CREADOR_URL}/reset_password.php`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, password })
        }
      );
      const data = await response.json();
      setEsError(!data.success);
      setMensaje(data.message);
      if (data.success) setCompletado(true);
    } catch (e) {
      setEsError(true);
      setMensaje('Error de conexi\u00F3n. Intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

const footerJSX = (
    <footer className="home-footer">
      <div className="home-footer-top">
        <div className="home-footer-redes">
          <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
            <i className="fab fa-tiktok"></i>
          </a>
          <a href="#" className="home-footer-social-link">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="#" className="home-footer-social-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
          <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
            <i className="fab fa-telegram"></i>
          </a>
        </div>
        <div className="home-footer-logo">
          <img
            src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
            alt="Ulalaaa Logo"
            className="home-footer-logo-img"
          />
        </div>
        <div className="home-footer-legal-links">
          <a href="/textos-legales#terminos" className="home-footer-legal-btn">
            {'Informaci\u00F3n Legal - T\u00E9rminos y Condiciones'}
          </a>
          <a href="/textos-legales#privacidad" className="home-footer-legal-btn">
            {'Pol\u00EDtica de Privacidad'}
          </a>
        </div>
      </div>
      <div className="home-footer-texto">
        {'Ulalaaa, es un sitio web exclusivo para mayores de 18 a\u00F1os, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relaci\u00F3n laboral con las personas publicadas.'}
      </div>
      <div className="home-footer-copyright">
        {'©2026 Ulalaaa - Todos los derechos Reservados.'}
      </div>
    </footer>
  );

  if (!token) {
    return (
      <div style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
        <div className="rc-wrapper" style={{flex:1}}>
          <div className="rc-container">
            <p className="rc-error-msg">
              {'Enlace inv\u00E1lido. Solicita uno nuevo desde el login.'}
            </p>
            <button className="rc-btn" onClick={() => navigate('/acceso-publicar')}>
              Ir al login
            </button>
          </div>
        </div>
        {footerJSX}
      </div>
    );
  }

return (
    <div style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
      <div className="rc-wrapper" style={{flex:1}}>
      <div className="rc-container">
        <div className="rc-logo">Ulalaaa</div>
        <h2 className="rc-titulo">
          {completado ? '\u00A1Contrase\u00F1a actualizada!' : 'Nueva contrase\u00F1a'}
        </h2>

        {!completado ? (
          <>
            <div className="rc-form-group">
              <label className="rc-label">Contrase&ntilde;a</label>
              <input
                type="password"
                className="rc-input"
                placeholder="Nueva contrase&ntilde;a"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
              <ul className="rc-validaciones">
                {validaciones.map((v, i) => (
                  <li key={i} className={v.ok ? 'rc-val-ok' : 'rc-val-pending'}>
                    {v.ok ? '\u2713 ' : '\u25CB '}{v.texto}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rc-form-group">
              <label className="rc-label">Repite Contrase&ntilde;a</label>
              <input
                type="password"
                className="rc-input"
                placeholder="Repite la contrase&ntilde;a"
                value={repite}
                onChange={(e) => setRepite(e.target.value)}
                disabled={isLoading}
              />
              {repite && (
                <p className={coinciden ? 'rc-coincide-ok' : 'rc-coincide-no'}>
                  {coinciden ? '\u2713 Contrase\u00F1as coinciden' : '\u2717 No coinciden'}
                </p>
              )}
            </div>

            {mensaje && (
              <p className={esError ? 'rc-msg-error' : 'rc-msg-ok'}>{mensaje}</p>
            )}

            <button
              className="rc-btn"
              onClick={handleSubmit}
              disabled={isLoading || !todasValidas || !coinciden}
            >
              {isLoading ? 'Guardando...' : 'CAMBIAR CONTRASE\u00D1A'}
            </button>
          </>
        ) : (
<>
            <p className="rc-subtexto">
              Tu contrasena fue actualizada correctamente.
              Ya puedes iniciar sesion con tu nueva clave.
            </p>
            <button className="rc-btn" onClick={() => navigate('/acceso-publicar')}>
              IR AL LOGIN
            </button>
          </>
        )}
</div>
      </div>
      {footerJSX}
    </div>
  );
};

export default RestablecerClave;